import React from 'react';

import { Paper, Typography } from '@material-ui/core';

import { tableEmptyStates } from '../../constants';
import useStyles from './EmptyTableState.styles';

export default function EmptyTableState({ stateKey, fullWidth }) {
  const classes = useStyles();
  const state = tableEmptyStates[stateKey];
  const Icon = state.icon;

  return (
    <Paper className={fullWidth ? classes.emptyWithdrawalCard : classes.emptyTableCard}>
      <div>
        <Icon className={classes.emptyIcon} />
        <Typography className={classes.emptyTitle}>{state.title}</Typography>
        <Typography className={classes.emptyDescription}>{state.description}</Typography>
      </div>
    </Paper>
  );
}
